import axios from "axios";
import authHeader from "@/services/auth-header";
import constantes from "@/constantes"
const API_URL = constantes.urlApi;

class RMSMD {


  //LEER EL PRODUCTO
  getProductoPlantilla(claveProducto) {
    return axios.get(
      API_URL +
      "/api/MenuDigital/GetProducto/" +
      claveProducto
    );
  }
  //Validar la reservación
  validaReservacionConCadena(data) {
    return axios.get(API_URL + "/api/Reservaciones/ValidaReservacion/" + data);
  }
  //Crear una reservacion
  creaReservacionSinAutenticacion(data) {
    return axios.post(API_URL + "/api/Reservaciones/CreaReservacionSinAutenticacion/", data);
  }
  //Obtener los datos del suscriptor por acceso directo
  getSuscriptorPorAccesoDirecto(nombreAccesoDirecto) {
    return axios.get(API_URL + "/api/Suscriptor/GetSuscriptorPorAccesoDirecto/" + nombreAccesoDirecto);
  }
  //Agregar un elemento a la lista de espera
  agregarElementoListaEspera(filaEspera) {
    return axios.post(API_URL + "/api/FilaEspera/AgregarElementoListaEspera/", filaEspera);
  }
  //Iniciar sesión, regresara un JWT
  getMenus(claveInstancia) {
    return axios.get(API_URL + "/api/MenuDigital/GetMenus/" + claveInstancia, {
      headers: this.getHeaderIdioma(),
    });
  }

  //Recuperar la contraseña
  recuperaContrasenia(nombreUsuario) {
    return axios.get(API_URL + "/api/MenuDigital/DoSolicitaRecuperaContrasenia/" + nombreUsuario);
  }
  //hacer login 
  doLogin(loginInfo) {
    return axios.post(API_URL + "/api/InicioSesion/InicioSesionSuscriptor", loginInfo);
  }
  //Registrar a un nuevo usuario
  registrarUsuario(Usuario) {
    return axios.post(API_URL + "/api/Cliente/RegistrarUsuario", Usuario);
  }
  //Obtener los datos del suscriptor
  getDatosSuscriptor(claveSuscriptor) {
    return axios.get(
      API_URL + "/api/MenuDigital/GetDatosSuscriptorConConfiguracion/" + claveSuscriptor
    );
  }

  getProductosBusqueda(claveSuscriptor, cadenaBusqueda, tampPag, pagActual) {
    return axios.get(
      API_URL +
      "/api/MenuDigital/GetProductosBusqueda/" +
      claveSuscriptor +
      "/" +
      cadenaBusqueda +
      "/" +
      tampPag +
      "/" +
      pagActual
    );
  }

  //Enviar la orden al servidor
  generarPedido(CrearPedido) {
    return axios.post(
      API_URL + "/api/OperacionesCliente/CrearPedido/",
      CrearPedido,
      {
        headers: authHeader(),
      }
    );
  }

  //LEER EL PRODUCTO
  getProducto(claveInstancia, claveProducto) {
    return axios.get(
      API_URL +
      "/api/MenuDigital/GetProducto/" +
      claveInstancia +
      "/" +
      claveProducto
    );
  }

  //Obtiene la estructura del menú digital en formato de arbol
  getMenuArbol(claveMenuDigital) {
    return axios.get(
      API_URL + "/api/MenuDigital/GetArbolMenu/" + claveMenuDigital, {
      headers: this.getHeaderIdioma(),
    }
    );
  }

  //Obtiene los productos
  getProductosClasificacion(claveMenuDigitalDetalle) {
    return axios.get(
      API_URL +
      "/api/MenuDigital/GetProductosClasificacion/" +
      claveMenuDigitalDetalle,
      {
        headers: this.getHeaderIdioma(),
      }
    );
  }

  getHeaderIdioma() {
    var idioma = 'es';
    var l = sessionStorage.getItem("Idioma");
    if (l != null) {
      idioma = l;
    }
    console.log(l);
    return { Idioma: idioma }
  }
}

export default new RMSMD();
